
$(document).ready(function () {

    var product_slug = $('#product_slug').val();
    var store_name = $("#store_name").val();
    // WARNING: For POST requests, body is set to null by browsers.
    var data = JSON.stringify({
    "store_name": store_name
    });
    
    var xhr = new XMLHttpRequest();
    
    xhr.addEventListener("readystatechange", function() {
      if(this.readyState === 4) {
       var jsonResponse = JSON.parse(this.responseText);
        if(jsonResponse.status == 1) {
            var html = '<form id="loyaltyForm">';
              html += '<div id="loggedIn-single-product-discount-phoneNum" class="single-product-discount-wrapper" style="background: '+ jsonResponse.frame_color  +'!important;padding: 25px 25px 45px!important;margin: 0!important;max-width: 44rem!important;font-weight: 300!important;">';
              html += '<h3 class="single-product-discount-title" style="color: '+ jsonResponse.header_text_color +'!important;font-weight: 300!important;">' + jsonResponse.header_text + '</h3>';
              html += '<div class="single-product-discount-sign-up-benefit-wrapper" style="background: #FFFFFF!important;border: 1px solid #E3E4DE!important;padding: 10px 15px!important;">';
              // if (window.matchMedia("(max-width: 600px)").matches) {
              //        $html += '<ul class="single-product-discount-sign-up-benefits" style="color: #414141!important;font-size: 9px;text-align: left;">';
              // } else {
              //         $html += '<ul class="single-product-discount-sign-up-benefits" style="color: #414141!important;padding-left: 20px; font-size: 14px;text-align: left; @media (max-width: 600px) { padding-left:0px !important; font-size: 9px !important; }">';
              // }
              html += jsonResponse.description
              html += '</div>';
              html += '<div class="single-product-discount-input-wrapper" style="display: flex!important;justify-content: space-between!important;margin-top: 15px!important;">';
              html += '<input class="single-product-discount-input-textInput" type="text" required id="email_field" placeholder="Din epost" name="phoneNumber" style="background: ' + jsonResponse.email_color + '!important;border-radius: 0!important;border-width: 1px!important;width: 70%!important;padding: 5px 15px!important;">';
              html += '<button id="phoneNum-submitBtn" class="single-product-discount-input-submitBtn" type="submit" style="padding-left:10px;width: 28%!important;cursor:pointer;color: ' + jsonResponse.button_color + '!important;background: ' + jsonResponse.button_background + '!important;font-weight: 300!important;border: 1px solid black!important;font-size: 14px;">' + jsonResponse.button_text + '</button>';
              html += '</div>';
              html += '</div>';
              html += '</form>';
              document.getElementById('discount').innerHTML = html;
  
          setTimeout(() => {
            if (window.matchMedia("(max-width: 600px)").matches) {
                $('.single-product-discount-sign-up-benefit-title').css('font-size', "");
                $('.single-product-discount-sign-up-benefit-title').css('font-size', "13px");
                $('.single-product-discount-sign-up-benefits').css('margin-left', "0");
                $('.single-product-discount-sign-up-benefits li').css('text-align', "start");
              }
          }, 500);
  
          $('#loyaltyForm').submit(function (e) { 
            e.preventDefault();
      
            var msg = '<p id="errormsg" style="color: red!important;font-size: 12px;margin: 0;padding: 0;">Vennligst skriv inn en gyldig e-postadresse</p>';
            var emailValue = $("#email_field").val();
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            
            if (!emailRegex.test(emailValue)) {
                $(msg).appendTo('#loggedIn-single-product-discount-phoneNum')
                return; // Stop form submission
            }
            window.location.href = '/a/loyalty?email=' + encodeURIComponent(emailValue) + '&product_slug=' + product_slug;
            
          });
        }
      }
    });
    
    xhr.open("POST", "https://dialog.modish.no/api/discount-attributes");
    xhr.setRequestHeader("Content-Type", "application/json");
    
    xhr.send(data);
  
});

